var map = {
	"./Discord.svg": "evr5",
	"./INSHORE.svg": "+Al2",
	"./SAILRANKS_BLACK.svg": "hG8Q",
	"./SailingSur.png": "9uG5",
	"./baner/1.jpg": "yEsP",
	"./baner/2.jpg": "9bgh",
	"./baner/Navegando.png": "C0an",
	"./baner/Navegando.webp": "22Hb",
	"./baner/Navegando2.png": "i4qr",
	"./baner/Navegando_2.png": "IyL2",
	"./baner/backdrop_1.png": "YLJZ",
	"./baner/backdrop_1b.png": "RsYL",
	"./baner/chart-img.jpg": "M9kZ",
	"./baner/hometow-bg.jpg": "xCj8",
	"./baner/imac.png": "xDL4",
	"./baner/pattern-bg.png": "H7N/",
	"./baner/repository-open-graph-template.png": "3MoP",
	"./baner/repository-open-graph.png": "aOXn",
	"./baner/sailRankshome2.png": "VB78",
	"./border.png": "u93X",
	"./esailingTV.png": "UklT",
	"./esailingTV.webp": "PYO1",
	"./esailingTV_2.png": "esPb",
	"./fave-icon1.png": "hLsZ",
	"./galicloud.png": "ae1Z",
	"./logo/1.png": "FIo+",
	"./logo/RFEV.svg": "7PAh",
	"./logo/esailing_logo - Copy.svg": "gnXL",
	"./logo/esailing_logo.svg": "tmaS",
	"./logo/esailing_logo_blanco.svg": "YFDZ",
	"./logo/footer-logo.png": "kqW2",
	"./logo/logo-trans-mini.png": "Zghc",
	"./logo/logo-trans.png": "Ooe/",
	"./logo/youtube.png": "zNvv",
	"./map-bg.jpg": "mY8D",
	"./pad-img.png": "Y0RM",
	"./pad-img1.png": "3/3q",
	"./pad-img2.png": "Kbn7",
	"./powerful-bg.jpg": "/1uR",
	"./quote.png": "hb/G",
	"./sailRankshome.png": "HhVZ",
	"./sailRankshome2.png": "mCbK",
	"./sailranks.png": "ugKT",
	"./startup.mp4": "xytN",
	"./startup1.mp4": "pJuj",
	"./tab/tab1.jpg": "ZWRO",
	"./tab/tab11.jpg": "AXq/",
	"./tab/tab2.jpg": "wBp7",
	"./tab/tab22.jpg": "x0Xf",
	"./tab/tab3.jpg": "+WsR",
	"./tab/tab4.jpg": "/0YQ",
	"./tab/tab44.jpg": "0Adg",
	"./testimonial1.png": "fFpU",
	"./vregattaHome.png": "h/9J",
	"./vregattaHome.webp": "g3UI",
	"./vregattaHome_2.png": "lw91",
	"./vregattaHome_3.png": "JjEg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4Qew";